
import '../styles/my-aeroval.css'

import { Collapse } from 'bootstrap';
import * as tus from 'tus-js-client'

import Highcharts from 'highcharts'

import * as utils from '../utils'
import * as io from '../components/io-users'
import { getCookie, setCookie } from '../components/cookies'
//import { evaluationWebSocket } from '../components/websocket';
import { makeConfigForms, updateVariableTab, collectConfigFromForms, setForm, updateConfig } from '../components/forms';

const anonymousImg = '/assets/images/anonymous.webp'

/*import interfaces*/
import { Aeroval } from '../types/global';
declare var aeroval: Aeroval;


export function initMyAeroval() {
  initUser();
  getPyaeroptions();
  getForms();

  if (aeroval.settings.theme) {
    document.querySelectorAll('.g-recaptcha').forEach(el => {
      el.setAttribute('data-theme', aeroval.settings.theme);
    });
  }

  const recaptchaWarningElement = document.getElementById('recaptcha-warning')
  if (recaptchaWarningElement && window.location.origin !== 'https://aeroval.met.no' && !window.location.origin.startsWith('http://localhost')) {
    recaptchaWarningElement.innerHTML = '<div class="alert alert-warning" role="alert">Signing up is only possible from the <a href="https://aeroval.met.no/#my-aeroval/">official AeroVal website</a></div>';
  }

  // add events for static forms
  const fileInput = document.getElementById('uploadFile') as HTMLInputElement;
  const uploadButton = document.getElementById('upload-but') as HTMLButtonElement;
  const makeCfgButton = document.getElementById('make-cfg-but') as HTMLButtonElement;

  fileInput.addEventListener('change', () => {
    uploadButton.disabled = !fileInput.files || fileInput.files.length === 0;
  });

  // enable submit button when both upload and make config are done
  const submitButton = document.getElementById('submit-but') as HTMLButtonElement;
  uploadButton.addEventListener('click', () => {
    if (uploadButton.disabled || makeCfgButton.disabled) return
    submitButton.disabled = false;
  })
  makeCfgButton.addEventListener('click', () => {
    if (uploadButton.disabled || makeCfgButton.disabled) return
    submitButton.disabled = false;
  })

}

function getForm(formId: string) {
  const formElement = (document.forms as any)[formId];
  if (!formElement) {
    console.error(`Form not found: ${formId}`);
    return;
  }

  // Define all form key sets in one place
  const formKeysMap: Record<string, string[]> = {
    'sign-in-form': ['mail', 'password'],
    'sign-up-form': ['firstname', 'lastname', 'mail', 'password'],
    'config-file-form': ['experiment', 'project', 'param', 'model', 'level'],
    'profile-form': ['firstname', 'lastname', 'mail', 'date', 'title', 'name', 'param', 'model', 'level'],
    'resetpassword-form': ['mail'],
  };

  const keys = formKeysMap[formId];
  if (!keys) {
    console.error(`Unknown form ID: ${formId}`);
    return;
  }

  // Build the form object
  const form: Record<string, string> = {};
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const input = formElement[i] as HTMLInputElement | undefined;
    form[key] = input?.value ?? '';
  }
  // Validate
  const error = checkForm(formId, form);
  if (error === 0) {
    return form;
  }
}

function checkForm(formId: string, form: Record<string, string>): number {
  let error = 0;

  const formKeysMap: Record<string, string[]> = {
    'sign-up-form': ['firstname', 'lastname', 'mail', 'password'],
    'subscription-form': ['name'],
    'config-file-form': ['experiment', 'project', 'param', 'model', 'level'],
  };

  const keys = formKeysMap[formId];
  if (!keys) return 0; // no validation needed for other forms

  // Identify the status element based on formId
  const statusElementId = formId.replace('-form', '-status');
  const statusElement = document.getElementById(statusElementId);

  for (const key of keys) {
    if (!form[key]?.trim()) {
      error++;
    }
  }

  // Show an error message if any field is empty
  if (error > 0 && statusElement) {
    statusElement.textContent = 'Please complete all the fields';
    statusElement.style.color = 'red';
    statusElement.style.display = 'block';

    // Smoothly fade out the message after 3 seconds
    setTimeout(() => {
      statusElement.style.transition = 'opacity 0.5s';
      statusElement.style.opacity = '0';
      setTimeout(() => (statusElement.style.display = 'none'), 500);
    }, 3000);
  }

  return error;
}


async function initUser() {
  const access_token = getCookie('access_token');
  const userData = await io.getUser(access_token)
  fillOutForms('user', userData);
  if (userData.id != -1) {
    fillInUserForms(userData);
  } else {
    showSignIn();
  }
  updateUserTables()
  showUserStats('user-stats')
  // update experiments table every 10 seconds
  setInterval(updateExperimentsTable, 10000, 'active-evaluations-table');

}

export async function signIn() {
  const formData = getForm('sign-in-form') as LoginData;
  const passwordStatusElement = document.getElementById('password-status')
  try {
    const loginResult = await io.loginUser(formData.mail, formData.password)
    if (loginResult.access_token) setCookie('access_token', loginResult.access_token, 7)
    passwordStatusElement!.innerHTML = 'login successful'
    passwordStatusElement!.className = 'text-success'
    setTimeout(async function () {
      initUser();
    }, 1000)
  } catch {
    passwordStatusElement!.innerHTML = 'wrong email/password'
    passwordStatusElement!.className = 'text-danger'
  }
}

async function fillInUserForms(data: UserData) {

  // --- Collapse show/hide ---
  hideCollapse('sign-in');
  hideCollapse('my-aeroval-intro')
  showCollapse('profile');
  showCollapse('new-eval');

  // --- Fill fields ---
  (document.getElementById("profile-firstname") as HTMLInputElement).value = data.firstname;
  (document.getElementById("profile-lastname") as HTMLInputElement).value = data.lastname;
  (document.getElementById("profile-email") as HTMLInputElement).value = data.mail;
  (document.getElementById("profile-date") as HTMLInputElement).value = data.date;

  // --- Profile pic initials ---
  const userPicture = document.getElementById("user-pic");
  userPicture!.innerHTML = `
    <div class="portrait p-2 mx-auto">
        <img class="card-img-top rounded-circle anonymous" src="${anonymousImg}" alt="Card image cap"></img>
        <span class="initials">${data['firstname'][0].toUpperCase()}${data['lastname'][0].toUpperCase()}</span>
    </div>`;

  // --- Enable the submit button ---
  const registerBtn = document.getElementById("register") as HTMLButtonElement | null;
  if (registerBtn) registerBtn.disabled = false;
}

async function showUserStats(divId: string) {
  const userStatsElement = document.getElementById(divId) as HTMLElement
  const userStats = await io.getUserStatsData(getCookie("access_token"))

  if (!userStatsElement || !userStats) return

  //make charts divisions
  userStatsElement.innerHTML = `
    <div id="user-storage-chart" class="w-50 user-chart"></div>
    <div id="user-evaluations-chart" class="w-50 user-chart"></div>
  `

  // plot chart
  plotPieChart('user-storage-chart', [
    {
      name: 'used',
      y: userStats.used_storage * 1e-9
    }, {
      name: 'left',
      y: (userStats.storage_quota - userStats.used_storage) * 1e-9
    }
  ], 'storage')

  plotPieChart('user-evaluations-chart', [{
    name: 'active',
    y: userStats.active_evaluations
  }, {
    name: 'left',
    y: userStats.active_evaluations_quota - userStats.active_evaluations
  }], 'evaluations')

}

type PieChartData = {
  name: string,
  y: number
}[]

function plotPieChart(divId: string, data: PieChartData, titleText: string) {
  const colors = ['#0d6efd', '#61a1fe']

  Highcharts.chart({
    chart: {
      renderTo: divId,
      margin: 15,
      spacing: [0, 0, 0, 0]
    },
    tooltip: {
      enabled: true,
      valueDecimals: 2,
    },
    title: {
      text: titleText,
      floating: false,
      y: 20,
      style: {
        fontSize: '12'
      }
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: true,
      floating: false,
      y: 5
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: 'pointer',
        colors,
        dataLabels: {
          enabled: false,
          format: '<b>{point.name}',
          distance: -60,
        }
      }
    },
    series: [{
      type: 'pie',
      data: data,
      showInLegend: true
    }]
  })
}

export async function uploadModelData() {
  const uploadStatusEl = document.getElementById('upload-status');
  if (!uploadStatusEl) return;

  // Clear previous status and prepare container for multiple progress bars
  uploadStatusEl.innerHTML = '<div id="uploads-container"></div>';

  const container = document.getElementById('uploads-container')!;

  // Disable upload button
  const uploadButElement = document.getElementById('upload-but') as HTMLButtonElement;
  uploadButElement.disabled = true;

  const inputElement = document.getElementById('uploadFile') as HTMLInputElement;
  const files = inputElement.files;
  if (!files || files.length === 0) {
    uploadButElement.disabled = false;
    return;
  }

  let completed = 0;
  const totalFiles = files.length;

  // Helper to refresh UI after any file finishes (success or error)
  const refreshUI = (success: boolean) => {
    const status = success ? 'success' : 'failed';
    updateBadgeStatus('upload-status', status);
    updateUserTables();
    showUserStats('user-stats');
    checkBadgesStatus();
  };

  // Process each file
  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    // Create individual progress bar for this file
    const fileId = `upload-${i}`;
    const progressHtml = `
    <div class="mx-4 upload-item" id="${fileId}-container">
      <div><strong>${file.name}</strong> (${(file.size / 1024 / 1024).toFixed(2)} MB)</div>
      <div class="progress" style="height: 20px;">
        <div 
          id="${fileId}-bar"
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          style="width: 0%;"
          aria-valuemin="0"
          aria-valuemax="100"
        >0%</div>
      </div>
    </div>
  `;
    container.insertAdjacentHTML('beforeend', progressHtml);

    const progressBar = document.getElementById(`${fileId}-bar`)!;
    let maxFadeDelay = 0;

    // Create tus upload for this file
    const upload = new tus.Upload(file, {
      endpoint: 'http://localhost:8080/files/',
      headers: {
        'Authorization': `Bearer ${getCookie('access_token')}`
      },
      retryDelays: [0, 3000, 5000],
      metadata: {
        filename: file.name,
        filetype: file.type
      },
      onError: (error: any) => {
        console.error('Failed uploading', file.name, error);
        const fadeDelay = 2000 + 500;
        maxFadeDelay = Math.max(maxFadeDelay, fadeDelay);

        progressBar.textContent = 'Error';
        progressBar.style.width = '100%';
        progressBar.classList.remove('progress-bar-animated');
        progressBar.classList.add('bg-danger');

        const containerEl = document.getElementById(`${fileId}-container`);

        // Fade out after a short delay (longer than success)
        setTimeout(() => {
          if (containerEl) {
            containerEl.classList.add('fade-out');

            setTimeout(() => {
              containerEl.remove();
            }, 500);
          }
        }, 2000);

        completed++;
        if (completed === totalFiles) {
          setTimeout(() => {
            refreshUI(false);
            uploadButElement.disabled = false;
          }, maxFadeDelay);
        }
      },
      onProgress: (bytesUploaded: number, bytesTotal: number) => {
        const percentage = Math.floor((bytesUploaded / bytesTotal) * 100);
        progressBar.style.width = `${percentage}%`;
        progressBar.textContent = `${percentage}%`;
        progressBar.setAttribute('aria-valuenow', percentage.toString());
      },
      onSuccess: () => {
        const fadeDelay = 1000 + 500;
        maxFadeDelay = Math.max(maxFadeDelay, fadeDelay);

        progressBar.textContent = '100% Complete';
        progressBar.style.width = '100%';
        progressBar.classList.remove('progress-bar-animated');
        progressBar.classList.add('bg-success');

        const containerEl = document.getElementById(`${fileId}-container`);

        // Fade out after 1 second
        setTimeout(() => {
          if (containerEl) {
            containerEl.classList.add('fade-out');

            // Remove from DOM after fade animation
            setTimeout(() => {
              containerEl.remove();
            }, 500);
          }
        }, 1000);

        completed++;
        if (completed === totalFiles) {
          setTimeout(() => {
            refreshUI(true);
            uploadButElement.disabled = false;
          }, maxFadeDelay)
        }
      }
    });

    // Resume if possible, then start
    upload.findPreviousUploads().then((previousUploads: any[]) => {
      if (previousUploads.length) {
        upload.resumeFromPreviousUpload(previousUploads[0]);
      }
      upload.start();
    });
  }
}

function updateUserTables() {
  updateUploadTable('upload-files-table')
  updateUploadedTable('uploaded-files-table')
  updateExperimentsTable('active-evaluations-table')
}

async function updateUploadTable(divId: string) {
  const uploadTableEl = document.getElementById(divId);
  if (!uploadTableEl) return;

  const uploadFiles = await io.getUploadedFiles(getCookie('access_token'));

  let rows = '';

  if (uploadFiles.length > 0) {
    for (const file of uploadFiles) {
      const fileStatus =
        file.finished === true || file.finished === false // the file is uploaded when in the database whatever the finished status is
          ? '<span class="badge bg-success">uploaded</span>'
          : '<span class="badge bg-danger">not uploaded</span>';

      rows += `
        <tr>
          <td class="file-name">${utils.escapeHtml(file.name)}</td>
          <td class="date">${file.upload_date}</td>
          <td>${utils.formatBytes(file.size)}</td>
          <td>${fileStatus}</td>
          <td><button class="badge border-0 bg-danger btn-file-delete" id="deleteFile-${file.id}"><i class="bi bi-trash-fill"></i></button></td>
        </tr>`;
    }
  } else {
    rows = `
      <tr>
        <td colspan="3" class="text-muted text-center">
          No uploads yet
        </td>
      </tr>`;
  }

  uploadTableEl.innerHTML = `
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>File Name</th>
          <th>Date</th>
          <th>Size</th>
          <th>Status</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  </div>
  `;

  // add events listener
  const deleteBtns = document.querySelectorAll('.btn-file-delete')
  deleteBtns.forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault()
      const confirmed = window.confirm(
        'Are you sure you want to delete this file?'
      )
      if (!confirmed) return
      const id = (btn as HTMLElement).id;
      await io.deleteFile(getCookie('access_token'), Number(id.split('-')[1]))
      updateUserTables()
      showUserStats('user-stats')
    });
  });

}

async function checkFileValidity(fileId: number) {
  const validityCell = document.getElementById(`file-validity-${fileId}`);
  if (!validityCell) return;
  validityCell.innerHTML = `<span class="badge bg-secondary">pending</span>`;

  while (true) {
    const fileData = await io.getUploadedFile(getCookie('access_token'), fileId);

    if (fileData.valid) {
      validityCell.innerHTML = `<span class="badge bg-success">valid</span>`;
    } else {
      validityCell.innerHTML = `<span class="badge bg-danger" title="${fileData.error || 'Unknown error'}">invalid</span>`;
    }

    if (fileData.finished) return

    // Still processing → wait and retry
    await utils.sleep(1000);
  }
}

async function updateUploadedTable(divId: string) {
  const uploadTableEl = document.getElementById(divId);
  if (!uploadTableEl) return;

  const uploadFiles = await io.getUploadedFiles(getCookie('access_token'));

  let rows = '';

  if (uploadFiles.length > 0) {
    for (const file of uploadFiles) {
      const fileValidity = file.valid
        ? `<span class="badge bg-success">valid</span>`
        : `<span class="badge bg-danger" title=${file.error}>invalid</span>`;
      const selectDisabled = file.valid ? '' : 'disabled';

      rows += `
        <tr>
          <td class="file-name">${utils.escapeHtml(file.name)}</td>
          <td class="date">${file.upload_date}</td>
          <td>${utils.formatBytes(file.size)}</td>
          <td id="file-validity-${file.id}">${fileValidity}</td>
          <td>
            <div class="form-check">
              <input class="form-check-input select-file" type="checkbox" value="" id="select-file-${file.id}" ${selectDisabled}>
              <label class="form-check-label" for="select-${file.id}">
              </label>
            </div>
          </td>
        </tr>`;
    }
  } else {
    rows = `
      <tr>
        <td colspan="3" class="text-muted text-center">
          No uploads yet
        </td>
      </tr>`;
  }

  uploadTableEl.innerHTML = `
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>File Name</th>
          <th>Date</th>
          <th>Size</th>
          <th>Validity</th>
          <th>Select</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  </div>
  `;

  if (uploadFiles.length > 0) {
    for (const file of uploadFiles) {
      checkFileValidity(file.id)
    }
  }

  // add events listener
  const selectBtns = document.querySelectorAll('.select-file')

  selectBtns.forEach(btn => {
    btn.addEventListener('change', async () => {

      // show status
      const configUpdateStatusElement =
        document.getElementById('config-update-status');
      configUpdateStatusElement?.classList.remove('d-none');

      // collect ALL selected ids
      const selected_ids = Array.from(
        document.querySelectorAll<HTMLInputElement>('.select-file:checked')
      ).map(cb => Number(cb.id.replace('select-file-', '')));

      const filesMetaData = await io.getFilesMetaData(
        getCookie('access_token'),
        selected_ids
      );
      (window as any).selectedFiles = selected_ids

      // Build objects that conform to FormattedFileMetaData 
      const formattedFilesMetaData: FormattedFileMetaData[] = filesMetaData.map((m: FileMetaData) => (
        {
          id: m.id,
          data_name: m.data_name.split(';'),
          variable_name: m.variable_name.split(';'),
          vertical_level: m.vertical_level.split(';'),
          unit: m.unit.split(';'),
          start: m.start,
          end: m.end,
          lat_min: m.lat_min,
          lat_max: m.lat_max,
          lon_min: m.lon_min,
          lon_max: m.lon_max,
          frequency: m.frequency
        }));

      updateConfigForms(formattedFilesMetaData);
      // hide status
      configUpdateStatusElement?.classList.add('d-none');
    });

  })
}

async function updateExperimentsTable(divId: string) {
  const tableEl = document.getElementById(divId);
  const refreshBtn = document.getElementById('active-evaluations-btn');
  if (!tableEl || !refreshBtn) return;

  // add refresh button
  refreshBtn.innerHTML = `<i class="bi bi-arrow-clockwise"></i>`;
  refreshBtn.classList.add('btn', 'btn-sm')
  refreshBtn.style.position = 'absolute';
  refreshBtn.style.top = '10px';
  refreshBtn.style.right = '10px';

  // Apply rotation
  void refreshBtn.offsetWidth;
  refreshBtn.style.transition = 'transform 1s ease-in-out';
  refreshBtn.style.transform = 'rotate(360deg)';

  // add onclick event
  refreshBtn.onclick = async () => {
    // Prevent multiple rapid clicks from breaking the animation
    if (refreshBtn.classList.contains('rotating')) return;
    refreshBtn.classList.add('rotating');

    // Force reflow to restart animation
    void refreshBtn.offsetWidth;

    // Apply rotation
    refreshBtn.style.transition = 'transform 1s ease-in-out';
    refreshBtn.style.transform = 'rotate(360deg)';

    // Trigger the actual refresh (your async table update)
    await updateExperimentsTable(divId);
    refreshBtn.classList.remove('rotating');

  }

  const experiments = await io.getUserExperimentsData(getCookie('access_token'));

  let rows = '';

  if (experiments.length > 0) {
    for (const experiment of experiments) {
      let experimentStatus;
      switch (experiment.status) {
        case 'submitted':
          experimentStatus = `<span class="badge bg-secondary">${experiment.status}</span>`;
          break;
        case 'pending':
          experimentStatus = `<span class="badge bg-secondary">${experiment.status}</span>`;
          break;
        case 'running':
          experimentStatus = `<span class="badge bg-primary">${experiment.status}</span>`;
          break;
        case 'available':
          experimentStatus = `<span class="badge bg-success">${experiment.status}</span>`;
          break;
        case 'failed':
          experimentStatus = `<span class="badge bg-danger">${experiment.status}</span>`;
          break;
        default:
          experimentStatus = `<span class="badge bg-secondary">unknown</span>`;
      }

      const classesLink = experiment.status == 'available' ? '' : 'disabled-link'

      rows += `
        <tr>
          <td>${experiment.project}</td>
          <td><a href="${experiment.url}" class="${classesLink}">${utils.escapeHtml(experiment.name)}</a></td>
          <td class="date">${experiment.date}</td>
          <td>${experimentStatus}</td>
          <td><button class="badge bg-primary border-0 btn-download" id="downloadCfgFile-${experiment.id}"><i class="bi bi-file-arrow-down-fill"></i></button></td>
          <td><button class="badge bg-danger border-0 btn-exp-delete" id="deleteExperiment-${experiment.id}"><i class="bi bi-trash-fill"></i></button></td>
        </tr>`;
    }
  } else {
    rows = `
      <tr>
        <td colspan="3" class="text-muted text-center">
          No active evaluation
        </td>
      </tr>`;
  }

  tableEl.innerHTML = `
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Project</th>
          <th>Experiment</th>
          <th>Date</th>
          <th>Status</th>
          <th>Cfg</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  </div>
  `;

  // add events listener
  const deleteBtns = document.querySelectorAll('.btn-exp-delete')
  deleteBtns.forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault()
      const confirmed = window.confirm(
        'Are you sure you want to delete this experiment?'
      )
      if (!confirmed) return
      const id = (btn as HTMLElement).id;
      await io.deleteExperiment(getCookie('access_token'), Number(id.split('-')[1]))
      updateUserTables()
      showUserStats('user-stats')
    });
  });

  const downloadBtns = document.querySelectorAll('.btn-download')
  downloadBtns.forEach(btn => {
    btn.addEventListener('click', async function () {
      const id = (btn as HTMLElement).id;
      await io.getCfgFile(getCookie('access_token'), Number(id.split('-')[1]))
    });
  });

}

function updateConfigForms(filesMetaData: FormattedFileMetaData[]) {
  const patch: Record<string, any> = {};

  // ── variables ─────────────────────────────────────
  const availableVariables = new Set<string>();
  for (const file of filesMetaData) {
    // create variable-verticalLayer
    for (let i in file.variable_name) {
      availableVariables.add(`${file.variable_name[i]}-${file.vertical_level[i].toLocaleLowerCase()}`)
    }
  }
  updateVariableTab(availableVariables);

  // ── frequencies ─────────────────────────────
  const frequencyForm = {
    type: 'multiselect',
    options: [] as (string)[],
    default: [] as (string)[]
  }
  const frequencies = filesMetaData.map(f => f.frequency as Aeroval['frequency']);
  frequencyForm.options = frequencies.length > 0 ? utils.filterFrequencies(['hourly', 'daily', 'monthly', 'yearly'], utils.getCoarsestFrequency(frequencies)) : []
  frequencyForm.default = frequencies.length > 0 ? frequencyForm.options : []

  // ── time period (full + individual years) ─────────────
  const availableYears = new Set<number>();
  for (const file of filesMetaData) {
    availableYears.add(file.start)
    availableYears.add(file.end)
  }
  const yearsArray = Array.from(availableYears).sort((a, b) => a - b) as (string | number)[];
  const minYear = yearsArray[0];
  const maxYear = yearsArray[yearsArray.length - 1];
  var periods = yearsArray
  if (minYear != maxYear)
    periods.unshift(`${minYear}-${maxYear}`)

  patch.time = {
    start: {
      type: 'text',
      default: minYear,
      disabled: true
    },
    end: {
      type: 'text',
      default: maxYear,
      disabled: true
    },
    periods: {
      type: 'multiselect',
      options: yearsArray,
      default: [...periods]
    },
    frequency: frequencyForm
  }

  updateConfig(patch, "time");
}

function showCollapse(id: string) {
  const el = document.getElementById(id);
  if (!el) return;

  // Ensure DOM visual state is consistent
  el.classList.add('show');

  // Get existing instance without auto-toggle
  let collapse = Collapse.getInstance(el);
  if (!collapse) {
    collapse = new Collapse(el, { toggle: false });
  }

  collapse.show();
}

function hideCollapse(id: string) {
  const el = document.getElementById(id);
  if (!el) return;

  // Get existing instance (DO NOT auto-initialize)
  let collapse = Collapse.getInstance(el);
  if (!collapse) {
    collapse = new Collapse(el, { toggle: false });
  }

  collapse.hide();
}

export function showSignUp() {
  showCollapse('my-aeroval-intro');
  showCollapse('sign-up');
  hideCollapse('sign-in');
  const mailStatus = document.getElementById('mail-status');
  if (mailStatus) mailStatus.innerHTML = '';
}

export function showSignIn() {
  showCollapse('my-aeroval-intro');
  showCollapse('sign-in');
  hideCollapse('sign-up');
  const passwordStatus = document.getElementById('password-status');
  if (passwordStatus) passwordStatus.innerHTML = '';
}

export function showResetPassword() {
  showCollapse('resetpassword');
  hideCollapse('sign-in');
  const resetStatus = document.getElementById('resetpassword-status');
  if (resetStatus) resetStatus.innerHTML = '';
}

export function showPrivacyPolicy() {
  showCollapse('privacy-policy');
  hideCollapse('sign-in');
}

export function hidePrivacyPolicy() {
  hideCollapse('privacy-policy');
  showCollapse('sign-in');
}

export function enableSignUp(captchaResponse: string) {
  const btn = document.getElementById("sign-up-but") as HTMLButtonElement;
  if (!btn) return
  btn.disabled = false;
  setCookie("recaptcha", captchaResponse, 1);
}

export function enableResetPassword(captchaResponse: string) {
  const form = (document.forms as any)["resetpassword-form"];
  const emailInput = form?.[0] as HTMLInputElement;
  const button = document.getElementById("resetpassword-but") as HTMLButtonElement;
  if (!emailInput || !button) return
  button.disabled = !emailInput.value.includes("@");
  setCookie("recaptcha", captchaResponse, 1);
}

export async function signUp(event?: Event) {
  event?.preventDefault(); // Prevent default form submission behavior
  const signUpData = getForm('sign-up-form');
  if (!signUpData) return;

  const mailStatus = document.getElementById('mail-status') as HTMLElement;
  const mailAction = document.getElementById('mail-action') as HTMLElement;
  if (!mailStatus || !mailAction) return

  try {
    const userData = await io.addUser(
      signUpData['firstname'],
      signUpData['lastname'],
      signUpData['mail'],
      signUpData['password'],
      getCookie('recaptcha')
    );

    setCookie('access_token', userData.access_token, 1);
    mailStatus.textContent = 'The profile has been successfully created';
    mailStatus.className = 'text-success';

    setTimeout(() => {
      initUser();
      hideCollapse('sign-up');
    }, 1000);

  } catch {
    mailStatus.textContent = 'This email address is already in use';
    mailStatus.className = 'text-danger';

    mailAction.innerHTML = `
            <br><a id="show-sign-in-but" href="#">Sign in</a>
            <br><a id="show-reset-password-but" href="#">Forgot your password</a>
        `;

    document.getElementById('show-sign-in-but')?.addEventListener('click', () => {
      showSignIn()
    })
    document.getElementById('show-reset-password-but')?.addEventListener('click', () => {
      showResetPassword()
    })
  }
}

async function checkConfigFileValidity(cfgFileId: string) {
  updateBadgeStatus('make-cfg-status', 'pending');

  while (true) {
    const cfgFileData = await io.getCfgFileMetaData(getCookie('access_token'), cfgFileId);

    if (cfgFileData.valid) {
      updateBadgeStatus('make-cfg-status', 'success');
      checkBadgesStatus();
      (window as any).cfgFileId = cfgFileId;
    }

    if (cfgFileData.error) {
      updateBadgeStatus('make-cfg-status', 'failed');
    }

    if (cfgFileData.finished) return

    // Still processing → wait and retry
    await utils.sleep(1000);
  }
}

export async function makeConfigFile() {
  const makeCfgStatusEl = document.getElementById('make-cfg-status');
  if (!makeCfgStatusEl) return;

  makeCfgStatusEl.innerHTML =
    '<span class="spinner-border spinner-border-sm" role="status"></span> Make cfg...';

  try {
    // get forms info as json friendly info
    const cfgFormsData = collectConfigFromForms();
    // add models
    cfgFormsData.files = (window as any).selectedFiles
    const cfgFileId = await io.addCfgFile(getCookie('access_token'), cfgFormsData)
    // check cfg validity
    checkConfigFileValidity(cfgFileId);
  } catch {
    updateBadgeStatus('make-cfg-status', 'failed');
  }
  checkBadgesStatus();
}

type BadgeStatus = 'success' | 'failed' | 'pending';
function updateBadgeStatus(divId: string, status: BadgeStatus) {
  const uploadStatusEl = document.getElementById(divId)
  if (!uploadStatusEl) return;

  switch (status) {
    case 'success':
      uploadStatusEl.innerHTML = '<span class="badge badge-pill bg-success">success</span>';
      break;
    case 'failed':
      uploadStatusEl.innerHTML = '<span class="badge badge-pill bg-danger">failed</span>';
      break;
    case 'pending':
      uploadStatusEl.innerHTML = '<span class="badge badge-pill bg-secondary">pending</span>';
      break;
  }
}

export async function submitEvaluation() {
  // reinitialize makecfg status
  const makeCfgStatusEl = document.getElementById('make-cfg-status');
  if (makeCfgStatusEl) makeCfgStatusEl.innerHTML = ''

  // get cfg file id
  const cfgFileId = (window as any).cfgFileId

  const statusEl = document.getElementById("submit-status");
  if (!statusEl) return;

  function showStatus(statusEl: HTMLElement, message: string, bootstrapClass: string, durationMs: number) {
    // Reset classes
    statusEl.className = bootstrapClass

    // Update message
    statusEl.textContent = message;

    // Show collapse
    showCollapse("submit-status");

    // Hide after delay
    setTimeout(() => {
      hideCollapse("submit-status");
    }, durationMs);
  }

  try {
    //console.log("submitting with cfgFileId:", cfgFileId)
    await io.submitExperiment(getCookie('access_token'), cfgFileId);
    showStatus(statusEl, "submitted", "badge badge-pill bg-success mx-auto", 3000);
    setTimeout(() => initUser(), 1000);
    //startEvaluation(cfgFormsData)
  } catch (err) {
    console.error(err);
    showStatus(statusEl, "failed", "badge badge-pill bg-danger mx-auto", 5000);
  }

  // reset forms
  getPyaeroptions()
}

export function logOut() {
  setCookie('access_token', 'null');
  hideCollapse("new-eval");
  hideCollapse("profile");
  showSignIn();
}

export async function resetPassword() {
  //get form to know what is selected
  const data = getForm('resetpassword-form');
  if (!data) return

  const statusElement = document.getElementById("resetpassword-status");
  if (!statusElement) return;

  try {
    const mail = data['mail']
    const recaptcha = getCookie('recaptcha')
    await io.emailPasswordChangeRequest(mail, recaptcha)

    statusElement.className = "text-success";
    statusElement.textContent = "An email has just been sent to you";
    statusElement.style.display = "block";

  } catch {
    statusElement.className = "text-danger";
    statusElement.textContent = "This email address is not registered";
    statusElement.style.display = "block";
  }

  // fade out nicely after 3s
  setTimeout(() => {
    statusElement.classList.add("fade-out");

    // remove from DOM after transition ends
    statusElement.addEventListener(
      "transitionend",
      () => {
        statusElement.classList.replace("fade-out", "hidden");
      },
      { once: true }
    );
  }, 3000);

}

async function getPyaeroptions() {
  const pyaeroptions = await io.getPyaeroptions()
  makeConfigForms(pyaeroptions, 'config-file-form')
  // fill in pi with user email
  const userData = await io.getUser(getCookie('access_token'))
  setForm('experiment.principal_investigator', userData.mail)
}

async function getForms() {
  const subForms = await utils.getConfig('sub-forms.json');
  (window as any).subscription = subForms;
  fillOutForms('config-file', subForms, 'make-cfg-but');
  fillOutForms('current-sub', subForms, 'update-but');
  checkBadgesStatus()
}

function fillOutForms(preKey: string, formsData: any, buttonId?: string) {
  const buttonElement = buttonId ? document.getElementById(buttonId) as HTMLButtonElement : null;
  for (let key in formsData) {
    const form = formsData[key];
    const formElement = document.getElementById(`${preKey}-${key}`)
    if (!formElement) continue
    let h = ''
    if (form.class == 'form-control') {
      const placeholder = form.placeholder ? `placeholder="${form.placeholder}"` : ''
      const required = form.required ? 'required' : ''
      h += `<label for="subForm">${form.title}</label>
            <input class="form-control" id="${preKey}-${key}" ${placeholder} ${required}>
            `;
    } else if (form.class == 'form-group') {
      h += `<div class="form-group">
            <label for="exampleFormControl${preKey}${key}">${form.title}</label>
            <select class="form-control" id="${preKey}-${key}">`;
      for (let option of form.options) {
        let disabled = option.disabled ? 'disabled' : ''
        h += `<option value="${option.value}" ${disabled}>${option.name}</option>`;
      }
      h += `</select>`;
      if (form.help) h += `<div id="help-${key}" class="form-text">${form.help}</div>`;
      h += `</div>`;
    }
    formElement.innerHTML = h;

    // activate button if all forms are filled
    if (!buttonElement) continue
    const inputs = formElement?.querySelectorAll('input, keyup, select, change');
    if (!inputs) return
    function updateButtonState() {
      const allFilled = Array.from(inputs).every(el => {
        if (el instanceof HTMLInputElement) {
          return el.type === 'checkbox' ? el.checked : el.value.trim() !== '';
        }
        return (el as any).value !== '';
      });

      if (buttonElement) buttonElement.disabled = !allFilled;
    }

    ['keyup', 'change', 'input'].forEach(event => {
      inputs.forEach(el => el.addEventListener(event, updateButtonState));
    });
  }

}

// Send sign-in form by pressing Enter key
document.getElementById('sign-in-password')?.addEventListener('keydown', (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    document.getElementById('sign-in-but')?.click();
  }
});


function checkBadgesStatus() {
  const divIds = ['make-cfg-status'];
  // count number of badges with success status
  let success = 0
  let total = 0
  divIds.forEach(divId => {
    const statusEl = document.getElementById(divId)
    if (!statusEl) return;
    if (statusEl.innerHTML.includes('bg-success')) success++
    total++
  });

  const submitButton = document.getElementById('submit-but') as HTMLButtonElement;
  if (!submitButton) return;
  // enable submit button if all badges are success
  submitButton.disabled = success < total
  const submitStatus = document.getElementById("submit-status") as HTMLButtonElement;
  if (submitButton.disabled == false) submitStatus.textContent = 'configuration valid'
}
